export const COGNITO = {
  REGION: "us-east-1",
  USER_POOL_ID: "us-east-1_iDuP02BTl",
  APP_CLIENT_ID: "4uceq6mvbvkhe5g2ottvju28bl",
};
